import { useId } from 'react';
import type { RequesterHelpdeskRuntime } from '@features/helpdesk/embed';
import type { HelpdeskWidgetConfiguration } from '../model/config';
import { HelpdeskContent } from './HelpdeskContent';

/** Full-page host: native navigation owns Close and Back, while the workflow stays mounted. */
export function HelpdeskStandalone({
  configuration,
  runtime,
}: {
  configuration: HelpdeskWidgetConfiguration;
  runtime: RequesterHelpdeskRuntime;
}) {
  const headingId = useId();
  return (
    <main
      aria-labelledby={headingId}
      className="mx-auto flex h-dvh w-full max-w-[800px] flex-col overflow-hidden bg-background font-sans text-sm text-foreground antialiased"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <HelpdeskContent
        configuration={configuration}
        runtime={runtime}
        headingId={headingId}
        headingLevel="h1"
      />
    </main>
  );
}
